import React, { useState } from "react";
import clsx from "clsx";

import Button from "@material-ui/core/Button";
import Dialog, { DialogProps } from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import Loader from "components/Loader";
import { useSnackbar } from "components/SnackbarContext/SnackbarContext";

import useStyles from "./styles";

export interface IProps extends DialogProps {
  onCancel: () => void;
  onConfirm: () => Promise<void>;
  children: React.ReactNode;
  title: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  positive?: boolean;
  isLoading?: boolean;
  notification?: string;
}

const ConfirmationPopup = (props: IProps) => {
  const {
    children,
    className,
    open = true,
    positive = true,
    onCancel,
    onConfirm,
    onClose,
    title,
    confirmButtonText,
    cancelButtonText,
    isLoading,
    notification
  } = props;

  const classes = useStyles();
  const { showSuccessSnack } = useSnackbar();

  const [isConfirmDisabled, setIsConfirmDisabled] = useState(false);

  const handleCancel = () => {
    onCancel();
  };

  const handleConfirm = () => {
    setIsConfirmDisabled(true);

    onConfirm()
      .then(() => {
        notification && showSuccessSnack(notification);
      })
      .catch(error => {
        console.error(error.message);
      })
      .finally(() => {
        setIsConfirmDisabled(false);
      });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={className}
      classes={{
        paper: classes.dialogPaper
      }}
    >
      {isLoading && <Loader overlay />}
      <DialogTitle className={classes.dialogTitle}>{title}</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {children}
      </DialogContent>
      <DialogActions>
        <Button className={classes.actionButton} onClick={handleCancel}>
          {cancelButtonText || "Cancel"}
        </Button>
        <Button
          className={clsx(classes.actionButton, {
            [classes.discard]: !positive,
            [classes.confirm]: positive
          })}
          disabled={isConfirmDisabled}
          onClick={handleConfirm}
        >
          {confirmButtonText || "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationPopup;
